import * as React from "react";
import { cn } from "../../lib/utils.jsx";

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="checkbox"
        className={cn(
          "h-4 w-4 rounded border-white/25 bg-white/5 text-indigo-500 align-middle",
          "focus:outline-none focus:ring-2 focus:ring-indigo-500",
          className
        )}
        {...props}
      />
    );
  }
);
Checkbox.displayName = "Checkbox";

export default Checkbox;

